import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-600">
                <span className="text-sm font-bold text-white">AIA</span>
              </div>
              <div className="ml-2">
                <div className="text-sm font-semibold text-white">
                  AI Implementation Advisor
                </div>
              </div>
            </div>
            <p className="mt-4 text-sm text-gray-400">
              Guidiamo le aziende italiane nell'implementazione di AI Agents per e-commerce,
              fornendo assessment personalizzati e roadmap concrete.
            </p>
          </div>

          {/* Links */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">
              Navigazione
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/assessment" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Assessment Gratuito
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">
              Contatti
            </h3>
            <div className="mt-4">
              <p className="text-sm text-gray-400">
                Email: info@blankgrowth.agency
              </p>
              <p className="text-sm text-gray-400 mt-2">
                Sviluppato da <a href="https://blankgrowth.agency/" title="_blank Growth Agency" 
                rel="noopener">_blank Growth Agency</a>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-800 pt-8">
          <p className="text-xs text-gray-400 text-center">
            © {new Date().getFullYear()} _blank Growth Agency. Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;